module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "width": _vm.modalWidth + 'px',
      "mask-closable": false,
      "class-name": "register-modal"
    },
    on: {
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('Steps', {
    attrs: {
      "current": _vm.currentSetp,
      "size": "small"
    }
  }, [_c('Step', {
    attrs: {
      "title": "个人注册/实名"
    }
  }), _vm._v(" "), _c('Step', {
    attrs: {
      "title": "完善企业信息"
    }
  }), _vm._v(" "), _c('Step', {
    attrs: {
      "title": "企业实名认证"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSetp == '0'),
      expression: "showSetp == '0'"
    }],
    staticClass: "reg-main"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("请扫码进行个人实名认证")]), _vm._v(" "), _c('div', {
    ref: "qrCodeUrl",
    staticClass: "qrcode"
  })]), _vm._v(" "), (_vm.showSetp == '1') ? _c('div', {
    staticClass: "reg-main join"
  }, [_c('p', {
    staticClass: "decs"
  }, [_vm._v("请选择您的企业名称")]), _vm._v(" "), _c('Form', {
    ref: "subForm",
    attrs: {
      "model": _vm.subForm,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "企业名称",
      "prop": "companyName"
    }
  }, [_c('Select', {
    staticClass: "no-icon",
    staticStyle: {
      "width": "355px",
      "margin-left": "-150px",
      "text-align": "left"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入企业全称",
      "remote-method": _vm.companySearch
    },
    model: {
      value: (_vm.subForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "companyName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "subForm.companyName"
    }
  }, _vm._l((_vm.companyList), function(option) {
    return _c('Option', {
      key: option.customerName,
      attrs: {
        "value": option.customerName
      }
    }, [_vm._v(_vm._s(option.customerName))])
  }), 1), _vm._v(" "), (_vm.showValidate) ? _c('p', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "85px",
      "color": "#f00"
    }
  }, [_vm._v("您的企业还未创建账户, 请前往"), _c('span', {
    staticClass: "login",
    on: {
      "click": function($event) {
        _vm.showSetp = 2
      }
    }
  }, [_vm._v("【创建企业账号】")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', [_vm._v("此处需要您的营业执照,请提前准备")])], 1) : _vm._e(), _vm._v(" "), (_vm.showSetp == '2') ? _c('div', {
    staticClass: "reg-main"
  }, [_c('create-company', {
    attrs: {
      "companyName": _vm.subForm.companyName
    },
    on: {
      "next": _vm.next,
      "createCompany": _vm.createCompany,
      "getCompany": _vm.getCompany
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSetp == '3') ? _c('div', {
    staticClass: "reg-main success4"
  }, [_c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#409eff",
      "font-size": "40px",
      "margin": "30px auto",
      "display": "block"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("\n          鸭嘴兽已收到您的加入企业信息, 我们将在30分钟内完成审核。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("审核结果将通过短信和微信通知您。")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("如需紧急开通，请电话联系：" + _vm._s(_vm.phone))])]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '7') ? _c('div', {
    staticClass: "reg-main success4"
  }, [_c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#409eff",
      "font-size": "40px",
      "margin": "30px auto",
      "display": "block"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("您的企业已创建成功!")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("点击下一步完成企业实名认证获取更多额度!")])]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '4') ? _c('div', {
    staticClass: "reg-main success5"
  }, [_c('div', {
    staticClass: "txt "
  }, [_vm._v("\n          应监管部门要求，为了保证贵司账号安全，避免产生法律风险，贵公司需要在网站进行企业实名认证。我们将采取对公打款认证，授权书认证或法定代表人认证的方式来验证您的本人与企业的身份，您的个人与企业信息将得到绝对的保护。\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '5') ? _c('div', {
    staticClass: "reg-main success4"
  }, [_c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#409eff",
      "font-size": "40px",
      "margin": "30px auto",
      "display": "block"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("企业实名认证成功")])]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '6') ? _c('statement', {
    attrs: {
      "isShow": _vm.statementFlag
    },
    on: {
      "next": _vm.next
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showSetp == '0') ? _c('Button', {
    staticClass: "next-btn",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.hasCertificationHttp(1)
      }
    }
  }, [_vm._v("\n          下一步\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '1') ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.joinLoading
    },
    on: {
      "click": function($event) {
        return _vm.valiSubmit('subForm')
      }
    }
  }, [_vm._v("\n          立即加入\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '4') ? _c('Button', {
    staticClass: "next-btn",
    staticStyle: {
      "width": "200px",
      "border-color": "#fff"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n          暂不实名\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '4') ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.getOrgAuthUrl
    }
  }, [_vm._v("\n          立即企业实名\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSetp == '7') ? _c('Button', {
    staticClass: "next-btn",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSetp = 4
      }
    }
  }, [_vm._v("\n          下一步\n        ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2b1ac8c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1ac8c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/new-register/index.vue
// module id = 1303
// module chunks = 61